import { fixNaN } from './fixNaN'

export const formatToPercentage = (value) => {
  return `${Number(fixNaN(value))
    .toFixed(2)
    .replace('.', ',')
    .replace(/,?0+$/, '')}%`
}
